import React, { Component } from "react";
import { Marker } from "react-leaflet";
import L, { DivIcon, LatLngExpression } from "leaflet";
import markericonblue from '../icons/marker-icon-2x-blue.png';
import markericongold from '../icons/marker-icon-2x-gold.png';
import markericonred from '../icons/marker-icon-2x-red.png';
import markericongreen from '../icons/marker-icon-2x-green.png';
import markericonorange from '../icons/marker-icon-2x-orange.png';
import markericonyellow from '../icons/marker-icon-2x-yellow.png';
import markericonviolet from '../icons/marker-icon-2x-violet.png';
import markericongrey from '../icons/marker-icon-2x-grey.png';
import markericonblack from '../icons/marker-icon-2x-black.png';
//import markericon from '.';
import markershadow from '../icons/marker-shadow.png';

interface AnimatedBadgeMarkerProps {
  position: LatLngExpression;
  value: string | number;
  badgeColor?: string;
  textColor?: string;
  iconUrl?: string;
  sx?: React.CSSProperties; // style overrides
  onClick?: () => void;
  anim?: boolean;
  children: any;
}

class AnimatedBadgeMarker extends Component<AnimatedBadgeMarkerProps> {
  createIcon = (anim:boolean): DivIcon => {
    const {
      value,
      badgeColor = "#d32f2f",
      textColor = "#fff",
      iconUrl = "https://unpkg.com/leaflet/dist/images/marker-icon.png",
      sx,
    } = this.props;

    // Convert sx overrides into inline CSS string
    const sxStyle = sx
      ? Object.entries(sx)
          .map(([k, v]) => `${k.replace(/[A-Z]/g, m => "-" + m.toLowerCase())}:${v}`)
          .join(";")
      : "";
    const animation = anim? 'pulse 1.4s infinite': undefined;
    const badgeHtml = `
      <Box 
        style="
          position:absolute;
          top:-12px;
          right:-10px;
          min-width:22px;
          height:22px;
          padding:0 6px;
          display:flex;
          align-items:center;
          justify-content:center;
          color:${textColor};
          font-size:12px;
          line-height:22px;
          text-align:center;
          border-radius:12px;
          z-index:10;
          background:${badgeColor};
          animation:${animation};
          ${sxStyle};
        "
      >${value}</Box>
    `;

    const html = `
      <style>
        @keyframes pulse {
          0% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(211,47,47,0.5);
          }
          70% {
            transform: scale(1.25);
            box-shadow: 0 0 0 10px rgba(211,47,47,0);
          }
          100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(211,47,47,0);
          }
        }
      </style>

      <Box style="position:relative; display:inline-block;">
        <img 
          src="${markericongreen}" 
          style="width:25px; height:41px;"
        />
        ${badgeHtml}
      </Box>
    `;

    return L.divIcon({
      html,
      className: "animated-badge-marker",
      iconSize: [30, 50],
      iconAnchor: [15, 50],
    });
  };

  render() {
    const { position, onClick, anim=false, children } = this.props;

    return (
      <Marker
        position={position}
        icon={this.createIcon(anim)}
        eventHandlers={{
          click: () => onClick?.(),
        }}
      >
        {children}
      </Marker>
    );
  }
}

export default AnimatedBadgeMarker;